module.exports = __WEBPACK_EXTERNAL_MODULE_115__;


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 115
// module chunks = 0